import React from 'react';
import { Link } from 'react-router-dom';

function ModeCard({ to, icon, title, description, highlighted = false }) {
    return (
        <Link to={to} className={highlighted ? 'mode-card mode-card--gold' : 'mode-card'}>
            <img className="mode-card__icon" src={icon} alt="" />
            <h2 className="mode-card__title">{title}</h2>
            <p className="mode-card__descr">{description}</p>
        </Link>
    );
}

export { ModeCard };
